export const fields = [
  {
    key: 'accountId',
    label: 'Account ID',
    value: 'ARK-100000',
    disabled: true,
    readOnly: true,
  },
  {
    key: 'companyName',
    label: 'Company Name',
    defaultValue: 'Ai-bees',
    placeholder: 'No company name added.',
  },
  {
    key: 'companyLogo',
    label: 'Company logo',
    defaultValue: 'ai-bees-logo.png',
    placeholder: 'No company logo added.',
  },
  {
    key: 'companyWebsite',
    label: 'Company website',
    defaultValue: 'Ai-bees.io',
    placeholder: 'No company website added.',
  },
  {
    key: 'invoiceEmail',
    label: 'Invoice email address',
    defaultValue: 'invoices@ai-bees.io',
    placeholder: 'No invoice email address added.',
  },
  {
    key: 'linkedin',
    label: 'Company linkedin',
    placeholder: 'No LinkedIn added.',
  },
  {
    key: 'twitter',
    label: 'Company twitter (X)',
    placeholder: 'No twitter added.',
  },
  {
    key: 'facebook',
    label: 'Company facebook',
    placeholder: 'No facebook added.',
  },
  {
    key: 'instagram',
    label: 'Company instagram',
    placeholder: 'No instagram added.',
  },
  {
    key: 'address1',
    label: 'Company address 1',
    defaultValue: 'N.04, 132 My Street, Kingston, New York 12401.',
    placeholder: 'Enter the address',
  },
  {
    key: 'address2',
    label: 'Company address 2',
    placeholder: 'Enter the address',
  },
  {
    key: 'postalCode',
    label: 'Postal code',
    placeholder: 'Enter postal code',
  },
  {
    key: 'country',
    label: 'Country',
    defaultValue: 'United States',
    placeholder: 'No country added.',
  },
];
